"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsernameAuthFormContainer = UsernameAuthFormContainer;
var React = _interopRequireWildcard(require("react"));
var _UsernameAuthForm = require("../../../../components/UsernameAuthForm");
var _ContentLayout = require("../../../../components/ContentLayout");
var _flow = require("../../../../types/flow");
var _validation = require("../../../../utils/validation");
var _formatPhone = require("../../../../utils/formatPhone");
var _view = require("../../../../types/view");
var _tracking = require("../../../../utils/tracking");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function UsernameAuthFormContainer(_ref) {
  let {
    isSubmitting,
    activeFlow,
    submitButtonText,
    login,
    loginError,
    isLoginInvalid,
    hasAsyncLoginError,
    password,
    passwordError,
    isPasswordInvalid,
    hasAsyncPasswordError,
    hasAsyncPhoneError,
    phoneError,
    changeLogin,
    changePassword,
    authenticate,
    register,
    checkEmail,
    changeView,
    changeFlow,
    resetToPhoneAuth,
    changeToPhoneAuth,
    autoFocusDisabled,
    isProfessionalUser,
    changeIsProfessionalUser,
    source
  } = _ref;
  // FORM
  const [changed, setChanged] = React.useState(false);
  const [touched, setTouched] = React.useState(false);

  // LOGIN
  const loginRef = React.useRef(null);
  const handleLoginChange = e => {
    const {
      value
    } = e.currentTarget;
    changeLogin(value.trim());
    setChanged(true);
  };
  React.useEffect(() => {
    if (loginRef.current) {
      loginRef.current.focus();
    }
  }, []);

  // PASSWORD
  const passwordRef = React.useRef(null);
  const handlePasswordChange = e => {
    const {
      value
    } = e.currentTarget;
    changePassword(value);
    setChanged(true);
  };
  const [passwordShown, setPasswordShown] = React.useState(false);
  const togglePasswordVisibility = React.useCallback(() => setPasswordShown(!passwordShown), [passwordShown]);
  const handleResetLinkClick = React.useCallback(e => {
    e.preventDefault();
    (0, _tracking.trackForgotPasswordClick)(source);
    changeView(_view.EActiveView.Restore, (0, _validation.isEmail)(login) ? {
      email: login
    } : undefined);
  }, [changeView, login, source]);

  // PHONE
  const phoneRef = React.useRef(null);
  const [phone, setPhone] = React.useState('');
  const isPhoneInvalid = React.useMemo(() => phone !== '' && !(0, _validation.isValidPhone)(phone), [phone]);
  const handlePhoneChange = value => {
    setPhone(value);
    setChanged(true);
  };

  // PRO USER
  const handleProfessionalUserChange = React.useCallback((e, value) => {
    changeIsProfessionalUser(value);
  }, [changeIsProfessionalUser]);

  // SUBMITION
  const handleFocusInvalid = React.useCallback(() => {
    if (isLoginInvalid && loginRef.current) {
      loginRef.current.focus();
      return;
    }
    if (isPasswordInvalid && passwordRef.current) {
      passwordRef.current.focus();
      return;
    }
    if (isPhoneInvalid && phoneRef.current) {
      phoneRef.current.focus();
      return;
    }
  }, [isPasswordInvalid, isPhoneInvalid, isLoginInvalid]);
  const handleSubmit = () => {
    setTouched(true);
    switch (activeFlow) {
      case _flow.EActiveFlow.Registration:
        if (isLoginInvalid || isPasswordInvalid || isPhoneInvalid) {
          handleFocusInvalid();
          return;
        }
        register({
          email: login,
          password,
          phone,
          isProfessional: isProfessionalUser,
          source
        });
        break;
      case _flow.EActiveFlow.Authentication:
        if (isLoginInvalid || isPasswordInvalid) {
          handleFocusInvalid();
          return;
        }
        authenticate({});
        break;
      default:
        if (isLoginInvalid) {
          handleFocusInvalid();
          return;
        }
        (0, _tracking.trackLoginResumeButtonClick)(source);
        if ((0, _validation.isEmail)(login)) {
          checkEmail();
        } else {
          (0, _tracking.trackShowTwoStepPassword)('id', source);
          changeFlow(_flow.EActiveFlow.Authentication);
        }
    }
    setChanged(false);
  };
  const switchView = () => {
    (0, _tracking.trackChangeLoginFlowTo)('phone', source);
    if ((0, _validation.isPhone)(login)) {
      const phone = (0, _formatPhone.formatPhone)(login);
      changeToPhoneAuth(phone);
    } else {
      resetToPhoneAuth();
    }
  };
  React.useEffect(() => {
    setPasswordShown(false);
    setPhone('');
    if ((activeFlow === _flow.EActiveFlow.Registration || activeFlow === _flow.EActiveFlow.Authentication) && passwordRef.current) {
      setTouched(false);
      setChanged(false);
      passwordRef.current.focus();
    }
  }, [activeFlow]);
  return /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement(_UsernameAuthForm.UsernameAuthForm, {
    activeFlow: activeFlow,
    handleSubmit: handleSubmit,
    isSubmitting: isSubmitting,
    submitButtonText: submitButtonText,
    autoFocusDisabled: autoFocusDisabled
    // LOGIN
    ,
    loginRef: loginRef,
    login: login,
    onLoginChange: handleLoginChange,
    loginError: !changed && loginError || undefined,
    isLoginInvalid: touched && (isLoginInvalid || !changed && hasAsyncLoginError)
    // PASSWORD
    ,
    passwordRef: passwordRef,
    password: password,
    passwordShown: passwordShown,
    isPasswordInvalid: touched && (isPasswordInvalid || !changed && hasAsyncPasswordError),
    passwordError: passwordError,
    togglePasswordVisibility: togglePasswordVisibility,
    onPasswordChange: handlePasswordChange,
    onResetLinkClick: handleResetLinkClick
    // PHONE
    ,
    phoneRef: phoneRef,
    phone: phone,
    onPhoneChange: handlePhoneChange,
    isPhoneInvalid: isPhoneInvalid || !changed && hasAsyncPhoneError,
    phoneError: phoneError
    // PRO USER
    ,
    isProfessionalUser: isProfessionalUser,
    onProfessionalUserChange: handleProfessionalUserChange,
    onSwitchAuthByPhone: switchView
  }));
}